import { ISearchResult } from "@model/Search.model";
import type { RootState } from "Data/Store/Store";


export const selectFlatIndex = (state: RootState): ISearchResult[] => {
  const { products = [], categories = [], services = [] } = state.searchReducer.searchCatalogByType;

  const entries = [
    { list: products, type: "product" as const },
    { list: categories, type: "category" as const },
    { list: services, type: "service" as const },
  ];

  return entries.flatMap(({ list, type }) =>
    list.map(({ label, slug, url }) => ({ label, slug, url, type }))
  );
};
